module.exports = " <div v-if=!exists class=checklist> <div class=checklist-danger> <input type=checkbox name=checkbox disabled=disabled /> <label><slot></slot></label> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ferments/partials/checklist-item.vue
// module id = 460
// module chunks = 2